import React from 'react';
import { StringParam, useQueryParam } from 'use-query-params';
import VolunteerDatabaseScreenAdvanced from './AdvancedVolunteerDatabaseScreen';
import VolunteerDatabaseScreenSimple from './SimpleVolunteerDatabaseScreen';

export const VolunteerDatabaseScreen = () => {
  const [selectedView] = useQueryParam('view', StringParam) ?? 'simple';

  if (selectedView === 'advanced') {
    return <VolunteerDatabaseScreenAdvanced />;
  }
  return <VolunteerDatabaseScreenSimple />;
};
